/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_UnassignedInputs */

const cs_settings_teams_unassigned = /** @type {(inputs: Settings_Teams_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez vedoucího`)
};

const en_settings_teams_unassigned = /** @type {(inputs: Settings_Teams_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No leader`)
};

/**
* | output |
* | --- |
* | "No leader" |
*
* @param {Settings_Teams_UnassignedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_unassigned = /** @type {((inputs?: Settings_Teams_UnassignedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_UnassignedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_unassigned(inputs)
	return cs_settings_teams_unassigned(inputs)
});